import { MarkdownParser } from '../utils/jsmind.markdown';
import { normalizeNodeTopicWhitespace } from '../../core/jsmind.node_topic.js';
import { NodeRenderer, NodeRenderContext, NodeRenderResult, stopChain } from './node-renderer';

const textRenderCache = new WeakMap<HTMLElement, string>();

export class TextNodeRenderer implements NodeRenderer {
  render(context: NodeRenderContext): NodeRenderResult {
    const { ele, node, options } = context;
    if (!(ele instanceof HTMLElement)) {
      return stopChain;
    }
    const topic = normalizeNodeTopicWhitespace(node.topic);
    const renderKey = `${options.support_html ? '1' : '0'}|${topic}`;
    const existingIndicators = ele.querySelector('.flashcard-indicators') as HTMLElement | null;
    const existingBadge = !existingIndicators
      ? (ele.querySelector('.flashcard-indicator') as HTMLElement | null)
      : null;
    const existingMetrics = ele.querySelector('.jmnode-metrics') as HTMLElement | null;
    if (textRenderCache.get(ele) === renderKey) {
      const hasEditor = !!ele.querySelector('.jsmind-editor');
      const textElement = ele.querySelector('.jmnode-content .jmnode-text') as HTMLElement | null;
      const hasRenderedText = Boolean(textElement && textElement.textContent !== null);
      if (!hasEditor && hasRenderedText) {
        return stopChain;
      }
    }

    const htmlContent = options.support_html
      ? MarkdownParser.parse(topic)
      : MarkdownParser.toPlainTextHtml(topic);
    const wrapper = document.createElement('span');
    wrapper.className = 'jmnode-content jmnode-content--text';

    const text = document.createElement('span');
    text.className = 'jmnode-text';
    text.innerHTML = htmlContent;

    wrapper.appendChild(text);
    ele.innerHTML = '';
    ele.appendChild(wrapper);
    textRenderCache.set(ele, renderKey);
    
    // Restore indicators if they existed
    if (existingMetrics) {
      ele.appendChild(existingMetrics);
    }
    if (existingIndicators) {
      ele.appendChild(existingIndicators);
    } else if (existingBadge) {
      ele.appendChild(existingBadge);
    }
    
    return stopChain;
  }
}
